import { PublicationDateContainer } from '../../containers/advancedFilters/PublicationDateContainer';
import { IFilter } from '../../types/filters';

export const publicationDate: IFilter = {
  component: PublicationDateContainer,
};
